var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container",
      class: { "required-fail": _vm.requiredFail }
    },
    [
      _c("input", {
        attrs: {
          type: "email",
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          id: _vm.fieldId
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.updateValue($event.target.value)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0639f21d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0639f21d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputTypesNPV/InputTypeEmailNPV.vue
// module id = null
// module chunks = 